document.addEventListener("DOMContentLoaded", () => {
  if (window.thumbslider) {
    window.thumbslider.on("update", bindThumbSlideClickEvents);
  }
  if (window.mainGallarySlider) {
    window.mainGallarySlider.on("update", bindThumbSlideClickEvents);
  }

  let interval = setInterval(function () {
    if (window.mainGallarySlider && window.thumbslider) {
      setTimeout(function () {
        let currentVariant = document.querySelector(
          ".product__info-wrapper [data-selected-variant]"
        ).innerHTML;
        // console.log(
        //   JSON.parse(currentVariant),
        //   "<<< JSON.parse(currentVariant)"
        // );
        if (currentVariant) {
          window.onVariantChange(JSON.parse(currentVariant));
        }
      }, 0);
      clearInterval(interval);
    }
  }, 100);

  setTimeout(function () {
    clearInterval(interval);
  }, 10000);

  var radioButton = document.querySelector('.swatch-input__input:active+.swatch-input__label, .swatch-input__input:checked');
    // Check if the radio button exists
    if (radioButton) {
      // Set the radio button's checked property to true
      radioButton.checked = true;
    
      // Create a new 'change' event
      var event = new Event('change', {
        bubbles: true, // The event will bubble up through the DOM
        cancelable: true // The event can be canceled
      });
    
      // Dispatch the 'change' event on the radio button
      radioButton.dispatchEvent(event);
    }
});

String.prototype.handle = function () {
  return this.toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
};

const isMatch = (arr1, arr2) => {
  return arr1.some((item1) =>
    arr2.some((item2) => item1.toString().handle() == item2.toString().handle())
  );
};

const bindThumbSlideClickEvents = () => {
  // console.log("call bindThumbSlideClickEvents");
  const thumbSlides = document.querySelectorAll(
   ".swiper.product-thumbs .swiper-slide:not(.hidden):not(.removeSlideItem)"
  );
  thumbSlides.forEach((slide, index) => {
    slide.addEventListener("click", () => {
      // console.log(thumbSlides?.length, slide, index, "<<<slide click");
      if (window.mainGallarySlider) {
        window.mainGallarySlider.slideTo(index);
      }
      highlightActiveThumbnail(thumbSlides);
    });
  });
};

const highlightActiveThumbnail = (thumbSlides) => {
  const activeIndex = window.mainGallarySlider
    ? window.mainGallarySlider.activeIndex
    : 0;
  thumbSlides.forEach((slide, index) => {
    if (index == activeIndex) {
      slide.classList.add("swiper-slide-thumb-active");
    } else {
      slide.classList.remove("swiper-slide-thumb-active");
    }
  });
};

window.onVariantChange = (variant) => {
  if (variant) {
    let variant_title = variant.title?.split(" / ");
    document
      .querySelectorAll(".product-main-slider [media-alts]")
      .forEach((el) => {
        let alts = el.getAttribute("media-alts");
        if (alts) {
          let alts_array = JSON.parse(alts);
          // console.log(variant_title, alts, isMatch(variant_title, alts_array));
          el.classList.add("removeSlideItem");
          if (isMatch(variant_title, alts_array)) {
            el.classList.remove("removeSlideItem");
          }
        }
      });
    document
      .querySelectorAll(".product__thumb-slider [media-alts]")
      .forEach((el) => {
        let alts = el.getAttribute("media-alts");
        if (alts) {
          let alts_array = JSON.parse(alts);
          // console.log(variant_title, alts, isMatch(variant_title, alts_array));
          el.classList.add("removeSlideItem");
          if (isMatch(variant_title, alts_array)) {
            el.classList.remove("removeSlideItem");
          }
        }
      });
    filterSwiperSlides(window.thumbslider);
    filterSwiperSlides(window.mainGallarySlider);
  } else {
    let currentProduct = document.querySelector(
      ".product__info-wrapper [data-product-json]"
    ).innerHTML;

    if (currentProduct) {
      let productOptionFieldsets = document.querySelectorAll(
        ".product__info-wrapper fieldset.product-form__input"
      );
      const product = JSON.parse(currentProduct);
      // console.log(
      //   productOptionFieldsets?.length,
      //   productOptionFieldsets,
      //   product,
      //   "<<< productOptionFieldsets"
      // );
      productOptionFieldsets?.forEach((fieldset, index) => {
        if (index == 0) {
          const av_opt = fieldset.querySelector(
            `[type="radio"]:not(.disabled)`
          );
          const checked = fieldset.querySelector(`[type="radio"]:checked`);
          // if (checked.getAttribute("data-option-unavailable") == "true") {
          //   av_opt?.click();
          // }
          if (checked) {
            const filterVarinat = product?.variants?.filter(
              (v) => v?.option1 === checked?.value
            );
            if (filterVarinat?.length) {
              let fieldsetWithOption2 = Array.from(productOptionFieldsets).find(
                (fieldset) => fieldset.getAttribute("option") == "2"
              );
              let fieldsetWithOption3 = Array.from(productOptionFieldsets).find(
                (fieldset) => fieldset.getAttribute("option") == "3"
              );
              fieldsetWithOption2
                ?.querySelector(
                  `[type="radio"][value="${filterVarinat[0]?.option2}"]`
                )
                ?.click();
              fieldsetWithOption3
                ?.querySelector(
                  `[type="radio"][value="${filterVarinat[0]?.option3}"]`
                )
                ?.click();
              // console.log(
              //   checked?.value,
              //   "<<<<<checked?.value>>>>>",
              //   filterVarinat,
              //   fieldsetWithOption2,
              //   fieldsetWithOption3
              // );
            }
          }
        }
      });
    }
  }
};

const filterSwiperSlides = (swiperInstance) => {
  swiperInstance.slides.forEach((slide) => {
    if (slide.classList.contains("removeSlideItem")) {
      slide.style.display = "none";
    } else {
      slide.style.display = "";
    }
  });
  setTimeout(function () {
    swiperInstance.update();
  }, 0);
  setTimeout(function () {
    swiperInstance.slideTo(0);
  }, 100);
};
